import type {FC} from 'react';
import React from 'react';
import logoPath from "./SMCLogo.svg"

interface SMCProps extends LogoSwitcherProps{
    [key: string]: any;
}

interface LogoSwitcherProps {
    org?: string;
    icon?: boolean;
}

const SMCLogo: FC<SMCProps> = (icon, props) => (
    <img
        alt="SMC Logo"
        src={logoPath}
        height={props.icon ? 100 : 60}
        width={props.icon ? 200 : 60}
        style={{
            margin: 1
        }}
        {...props}
    />
);
export default SMCLogo;